export default "__VITE_ASSET__BNlOQuyO__"